import PlusMinusButtonChanger from 'components/WorkoutTemplateBuilder/Components/PlusMinusButtonChanger'

export default function SetUnitsButton({ mode, phaseIndex, exerciseIndex, exercise, setIndex, set, mutateExercise }) {
    switch (mode) {
        // Edit Mode
        case 'edit':
            // For reps set unit type
            if (exercise.setUnit === 'reps') {
                return (
                    <div className="h-6 w-60 flex justify-center items-center border-x border-stone-400">
                        <PlusMinusButtonChanger
                            label="Reps:"
                            value={set.reps}
                            setIndex={setIndex}
                            lateral={exercise.lateral}
                            handleAddFunction={() => mutateExercise('individual-add-rep', phaseIndex, exerciseIndex, setIndex)}
                            handleSubtractFunction={() => mutateExercise('individual-subtract-rep', phaseIndex, exerciseIndex, setIndex)}
                        />
                    </div>
                )
            }

            // For seconds set unit type
            if (exercise.setUnit === 'seconds') {
                return (
                    <div className="h-6 w-60 flex justify-center items-center border-x border-stone-400">
                        <PlusMinusButtonChanger
                            label="Time:"
                            value={set.seconds}
                            setIndex={setIndex}
                            lateral={exercise.lateral}
                            setUnit={exercise.setUnit}
                            handleAddFunction={() => mutateExercise('individual-add-seconds', phaseIndex, exerciseIndex, setIndex)}
                            handleSubtractFunction={() => mutateExercise('individual-subtract-seconds', phaseIndex, exerciseIndex, setIndex)}
                        />
                    </div>
                )
            }

            break

        // View mode
        case 'view':
            // For reps set unit type
            if (exercise.setUnit === 'reps') {
                return (
                    <div className="h-6 w-60 flex justify-center items-center border-l border-stone-400">
                        Reps: {set.reps} {exercise.lateral === 'unilateral' ? ' / side' : ''}
                    </div>
                )
            }

            // For seconds set unit type
            if (exercise.setUnit === 'seconds') {
                return (
                    <div className="h-6 w-60 flex justify-center items-center border-l border-stone-400">
                        Time: {set.seconds} s {exercise.lateral === 'unilateral' ? ' / side' : ''}
                    </div>
                )
            }

            break

        // Error Message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
